import Register from "../components/Register"
import React from "react"

const RegisterPage = () => {
    return (
        <div>
            <Register />
        </div>
    )
}

export default RegisterPage
